/**
 * Archive JS controller.
 */

// Use jQuery as $ within this file scope.
const $ = jQuery;

/**
 * Class Archive
 */
export default class Archive {

    /**
     * Cache dom elements for use in the class's methods.
     */
    cache() {

        // Load more posts button.
        this.loadMoreButton  = $( '#js-load-more-button' );
        this.loadMoreText    = $( '#js-load-more-text' );
        this.loadMoreSpinner = $( '#js-load-more-spinner' );

        // Posts container.
        this.postsWrapper = $( '#js-article-list' );

        // data-attributes for load more.
        this.postsPerPage = this.postsWrapper.attr( 'data-posts-per-page' );
        this.foundPosts   = this.postsWrapper.attr( 'data-found-posts' );
        this.model        = this.postsWrapper.attr( 'data-model' );
    }

    /**
     * All common events
     */
    events() {

        // When load more button is clicked.
        this.loadMoreButton.on( 'click', ( e ) => {
            this.loadMorePosts();
        });
    }

    /**
     * Load images by slug.
     *
     * @param {string} slug Slug.
     */
    loadMorePosts() {

        // Assign this to thisClass to pass inside success.
        const thisClass = this;

        // Add iteration to current set keep on tracking how many clicks.
        const currentSet = this.postsWrapper.attr( 'data-current-set' );
        const added = +currentSet + 1;
        const totalNumOfPosts = ( +added * +this.postsPerPage );

        // Hide load more text and show spinner.
        this.loadMoreText.toggleClass( 'hidden' );
        this.loadMoreSpinner.toggleClass( 'hidden' );

        dp( `${this.model}/Query`, {
            partial: 'load-more-articles',
            tidy: true,
            data: true,
            args: {
                /*eslint-disable */
                ajax_params: {
                    currentSet: added,
                }
                /*eslint-enable */
            }
        }).then( ( response ) => {

            // Hide spinner and show load more text.
            this.loadMoreText.toggleClass( 'hidden' );
            this.loadMoreSpinner.toggleClass( 'hidden' );

            // Append posts to the wrapping element.
            thisClass.postsWrapper.append( response.success );

            // Set new value to data-attribute data-current.
            this.postsWrapper.attr( 'data-current-set', added );

            // If found posts is less than total number of posts hide the load more button.
            if ( thisClass.foundPosts <= totalNumOfPosts ) {
                this.loadMoreButton.addClass( 'hidden' );
            }
        }).catch( ( error ) => {
            console.log( error );
        });
    }

    /**
     * Run when the document is ready.
     */
    docReady() {
        this.cache();
        this.events();
    }
}



// WEBPACK FOOTER //
// ./assets/scripts/archive.js